import { getRequirementId, isRequirementRef } from '../../../../../util/directoryRoleRequirement.util'

const buildDirectoryRoleRequirementOptionsMap = (values = []) =>
  Object.fromEntries(values.filter(isRequirementRef).map((value) => [value, getRequirementId(value)]))

export default buildDirectoryRoleRequirementOptionsMap
